import { QuotaAction } from '../actions/quotaActions';
import { AppQuota } from '../models/quota';

// currently not used
export const quotaReducer = (appQuota: AppQuota, action: QuotaAction): AppQuota => {
    switch (action.type) {
        case 'SET_QUOTA': {
            const userQuotaPercentage = action.payload.userQuota?.tokenQuotaPerPeriod ? ((action.payload.userQuota.tokensLeftInPeriod ?? 0) / action.payload.userQuota.tokenQuotaPerPeriod) * 100 : 0;
            return { ...appQuota, userQuota: action.payload.userQuota, userQuotaPercentage };
        }
        case 'UPADTE_REMAINING_QUOTA': {
            const userQuotaPercentageUpdate = action.payload.limit ? ((action.payload.remaining ?? 0) / action.payload.limit) * 100 : undefined;
            if (appQuota.userQuota) {
                return {
                    ...appQuota,
                    userQuotaPercentage: userQuotaPercentageUpdate !== undefined ? userQuotaPercentageUpdate : appQuota.userQuotaPercentage,
                    userQuota: {
                        ...appQuota.userQuota,
                        tokensLeftInPeriod: action.payload.remaining !== undefined ? action.payload.remaining : appQuota.userQuota?.tokensLeftInPeriod,
                        tokenQuotaPerPeriod: action.payload.limit !== undefined ? action.payload.limit : appQuota.userQuota?.tokenQuotaPerPeriod,
                    },
                };
            }
            return appQuota;
        }
        default:
            return appQuota;
    }
};
